// * GET =====================================
export const UTILS_LOG_GET_GET_QUERY_HISTORY_INLINE = `/utils_log/get_query_history_inline`;

export const UTILS_LOG_GET_GET_OUTPUT_LOGS = `/utils_log/get_output_logs`;

export const UTILS_LOG_GET_GET_QUERY_HISTORY_LOGS = `/utils_log/get_query_history_logs`;

export const UTILS_LOG_GET_GET_OUTPUT_LOGS_DETAILS = `/utils_log/get_output_logs_details`;

export const UTILS_LOG_GET_GET_SYNOPSIS_LOG = `/utils_log/get_synopsis_log`;

export const UTILS_LOG_GET_GET_USER_ACTION_LOG_EXTRA_METADATA = `/utils_log/get_user_action_log_extra_metadata`;
// * PATCH ===================================

// * POST ====================================

// * DELETE ==================================

// * PUT =====================================
